import { clientPortalRequest, buildClientQuery } from "./clientPortalFetch";

function viewBase(clientViewId) {
  return `/views/${clientViewId}`;
}

export function getAnalyticsSummary(clientViewId, params = {}) {
  return clientPortalRequest(`${viewBase(clientViewId)}/analytics/summary${buildClientQuery(params)}`);
}

export function getAnalyticsTrends(clientViewId, params = {}) {
  return clientPortalRequest(`${viewBase(clientViewId)}/analytics/trends${buildClientQuery(params)}`);
}

export function getAnalyticsPipeline(clientViewId, params = {}) {
  return clientPortalRequest(`${viewBase(clientViewId)}/analytics/pipeline${buildClientQuery(params)}`);
}

export function getAnalyticsSources(clientViewId, params = {}) {
  return clientPortalRequest(`${viewBase(clientViewId)}/analytics/sources${buildClientQuery(params)}`);
}

export function getAnalyticsCommunities(clientViewId, params = {}) {
  return clientPortalRequest(
    `${viewBase(clientViewId)}/analytics/communities${buildClientQuery(params)}`
  );
}

export function getAnalyticsCourses(clientViewId, params = {}) {
  return clientPortalRequest(`${viewBase(clientViewId)}/analytics/courses${buildClientQuery(params)}`);
}

export function getAnalyticsRecentActivity(clientViewId, params = {}) {
  return clientPortalRequest(
    `${viewBase(clientViewId)}/analytics/recent-activity${buildClientQuery(params)}`
  );
}

export function getOpportunityReport(clientViewId, params = {}) {
  return clientPortalRequest(
    `${viewBase(clientViewId)}/reports/opportunities${buildClientQuery(params)}`
  );
}

export function getCommunityReport(clientViewId, params = {}) {
  return clientPortalRequest(
    `${viewBase(clientViewId)}/reports/communities${buildClientQuery(params)}`
  );
}

export function getCourseReport(clientViewId, params = {}) {
  return clientPortalRequest(`${viewBase(clientViewId)}/reports/courses${buildClientQuery(params)}`);
}

export function getSourceReport(clientViewId, params = {}) {
  return clientPortalRequest(`${viewBase(clientViewId)}/reports/sources${buildClientQuery(params)}`);
}

export function exportReportCsv(clientViewId, params = {}) {
  const query = buildClientQuery(params);
  return fetch(`/api/client${viewBase(clientViewId)}/reports/export${query}`, {
    credentials: "include",
  }).then(async (res) => {
    if (!res.ok) {
      const body = await res.json().catch(() => ({}));
      throw new Error(body.message || "Export failed.");
    }
    return res.blob();
  });
}
